import theme from '../../../lib/theme';
import { hexToRGB } from '../Carousel';

const {
  corners,
  scale,
  shadows,
  colors,
  media,
  layouts,
  font: {
    families,
    heights,

    ...font
  },
} = theme;

export default () => ({
  link: {
    ...layouts.spacedColumn('s'),
    textDecoration: 'none !important',

    '&:hover *': {
      //  override hover underline
      textDecoration: 'none !important',
    },

    '&:hover .Holiday__title': {
      color: colors.sas.primary,
    },

    '&:hover .Holiday__image': {
      display: 'flex',
    },
  },

  text: {
    ...layouts.spacedColumn('xxs'),
    margin: '0!important',
    alignItems: 'flex-start',
  },

  tag: {
    display: 'inline-block',
    borderBottomRightRadius: corners.m,
    textTransform: 'uppercase',
    padding: `${scale.xxxxs} ${scale.xs}`,
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundColor: colors.red,
    color: colors.white,
    fontFamily: families.primary,
    fontSize: font.l,
    fontWeight: font.bold,
    lineHeight: heights.xl,
  },

  title: {
    color: colors.black,
    fontFamily: families.primary,
    fontSize: font.l,
    fontWeight: font.normal,
    lineHeight: heights.xl,
    marginBottom: 0,
    transition: 'all 150ms linear',
  },

  category: {
    color: colors.sas.primary,
    fontFamily: families.primary,
    fontSize: font.l,
    fontWeight: font.bold,
    lineHeight: heights.l,
    textDecoration: 'none',
  },

  highlight: {
    backgroundColor: colors.tas.secondary,
    color: colors.black,
    fontSize: font.l,
    fontFamily: families.primary,
    lineHeight: heights.l,
    marginLeft: `-${scale.xxs}`,
    padding: `${scale.xxxs} ${scale.xxs}`,

    [media.l.up]: {
      width: 'auto',
    },
  },

  priceContainer: {
    ...layouts.spacedRow('xxxs'),
    marginTop: `${scale.xxxxs}!important`,
  },

  subtitle: {
    fontFamily: families.primary,
    fontSize: font.m,
    lineHeight: heights.m,
    color: colors.black,
  },
  price: {
    fontFamily: families.primary,
    fontSize: font.xl,
    fontWeight: font.bold,
    lineHeight: heights.m,
    color: colors.black,
  },

  image: {
    width: '100%',
    display: 'block',
  },

  imageBackground: {
    display: 'flex',
    flex: 1,
    height: '100%',
    top: 0,
    left: 0,
    position: 'absolute',
    width: '100%',

    '& > button': {
      border: `2px solid ${colors.white}`,
      backgroundColor: hexToRGB(colors.white, '0.8'),
      color: colors.tas.primary,
      fontFamily: families.primary,
      fontSize: font.m,
      fontWeight: font.normal,
      lineHeight: heights.xxl,
      display: 'inline-block',
      position: 'absolute',
      left: 'calc(50% - 85px)',
      width: '170px',
      top: 'calc(50% - 22.5px)',
      height: '45px',
      borderRadius: '28.5px',
      cursor: 'pointer',
    },
  },

  featureImageContainer: {
    position: 'relative',
    width: '100%',
  },
});
